import React, { Component } from 'react';
import * as wConst from "../consts/website-consts";
import * as wActs from "../actions/website-actions";
import Select from "react-select";

class ProfileSelectBox extends Component {

  constructor(props) {
    super(props);
    this.state = {
      value: "",
      placeholder: props.placeholder,
      isDisabled: props.isDisabled,
      onChange: props.onChange,
      defaultValue: props.defaultValue,
      inputValue: "",
      options: [],
    };

  }



  handleChange(sel) {
    this.setState({value: sel});
    if(typeof this.state.onChange === "function") {
      this.state.onChange(sel);
    }
  }

  componentDidMount() {
    this.load("");
  }


  load(i) {
    let self = this;
    const ref = wActs.GetReferer();
    let headers = {
      'X-Alt-Referer': "https://www.topescort.com",
      'Authorization': 'Bearer ' + wActs.getBearer()
    };
    fetch(`${wConst.ROOT_URL()}/agent/models?term=${i}&sort=alphabetically`, {headers: headers})
      .then(resp => resp.json())
      .then(function(data) {
          let rArr = data.Result.map((v) => {
            return {value: v.Id, label: v.EscortName, url: v.Url.replace("escortspots","topescort")};
          });
          self.setState({options: rArr});
        }
      );
  }


  handleInputChange(val) {
    this.setState({ inputValue: val });
    if(val.length>=2) {
      this.load(val);
    }
    return val;
  }

  render() {
    return (
      <Select
        ref={(ref) => {this.Select = ref}}
        placeholder={this.state.placeholder}
        onChange={(sel) => {this.handleChange(sel)}}
        value={this.state.value}
        options={this.state.options}
        onInputChange={(val) => {return this.handleInputChange(val)}}
      />
    );
  }
}

export default ProfileSelectBox;
